<template>
    <div class="main-container">
        <img class="logo" src="../../assets/ChatDiary/icon.png" alt="Logo"/>
        <span class="desc">Chat Diary uses Apple's CloudKit service to sync your data in the cloud. CloudKit helps you to get more control over your app data,
            and you can always disable cloud services in iCloud settings. <br>
            We don't collect any of your personal data. Enjoy!
        </span>
    </div>
</template>

<style scoped>
    .main-container{
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height:100%;
        width:100%;
    }

    .logo{
        max-width:320px;
        width:80%;
        border-radius: 50px;
    }

    .desc{
        font-size:14pt;
    }
</style>

<script>

    export default {
        name: "DrifterPolicy"
    }

</script>